export default __webpack_public_path__ + "static/media/6.ded885a1.jpg";